export function calculateReadTime() {
    var article = document.querySelectorAll('main');
    var readTimeDiv = document.getElementById('readtime');

    if (!readTimeDiv) { return; }

    var calculateReadTime = function calculateReadTime() {
        var numOfWords = 0;
        var averageWPM = 260;
        article.forEach(function (article) {
            numOfWords += article.innerHTML.split(' ').length;
        });
        var readTime = numOfWords / averageWPM;
        return readTimeDiv.innerHTML = Math.ceil(readTime) + ' ' + 'min. leestijd';
    };

    calculateReadTime();
}

export function toc() {
  // Create tabel of contents from all the h2 and h3 tags in the main content, linking to the ids of the headers.

  var toc = document.getElementById('tocDiv');
  var headers = document.querySelectorAll('main h2');
  // if no headers return
    if (!headers.length) {
        return;
    }

  var tocContent = '<ul>';
  headers.forEach(function (header) {
      var id = header.id;
      //if header id is equal to "inhoudsopgave" skip this header
      if ( id === 'inhoudsopgave' || id === 'over-auteur' || id === 'andere-interessante-artikelen' ) {
          return;
      }

      // if header id is within section .wp-block-indrukwekkend-al-het-nieuws skip this header
      if (header.closest('.wp-block-indrukwekkend-al-het-nieuws') || header.closest('.whitepaperBlock')) {
          return;
      }

      // if header id is empty, create one
      if (!id) {
          id = header.textContent.replace(/\s+/g, '-').toLowerCase();
          header.id = id;
      }
      var text = header.textContent;
      var level = header.tagName.slice(-1);
      tocContent += '<li class="toc-level-' + level + '"><a href="#' + id + '">' + text + '</a></li>';
  });

  tocContent += '</ul>';
  toc.innerHTML = tocContent;

}